import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { cloneDeep, filter, findIndex, forEach } from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { MessageService } from 'src/app/shared/services/message/message.service';
import { LanguageData } from 'src/app/translation/shared/playbook-translation.interface';

@Component({
    selector: 'app-select-language',
    templateUrl: './select-language.component.html',
    styleUrls: ['./select-language.component.scss'],
    standalone: false
})
export class SelectLanguageComponent implements OnInit {

  playbookLanguages: Array<LanguageData>;
  pinnedPlaybookLanguage: number = null;
  constPlaybookLanguages: Array<LanguageData>;
  languagesSubject = new Subject();
  isAllowed: boolean;
  constructor(
    private bsModalRef: BsModalRef,
    private messageservice: MessageService
  ) { }

  ngOnInit() {
    const LanguageDatas = this.playbookLanguages;
    forEach(this.constPlaybookLanguages, (constPlaybookLanguage) => {
      const index = findIndex(this.playbookLanguages, (playbookLanguage) => constPlaybookLanguage.id === playbookLanguage.id);
      if (index === -1) {
        constPlaybookLanguage.isSelected = false;
        LanguageDatas.push(constPlaybookLanguage);
      }
    });
    this.playbookLanguages = LanguageDatas;
    this.checkSelectedLanguages(false);
  }
  close() {
    this.bsModalRef.hide();
  }
  save() {
    const Languages: Array<any> = filter(this.playbookLanguages, (playbookLanguage) => playbookLanguage.isSelected);
    if (this.pinnedPlaybookLanguage) {
      const index = findIndex(Languages, (playbookLanguage) => this.pinnedPlaybookLanguage === playbookLanguage.id);
      if (index !== -1) {
        const pinnedLangData = Languages.splice(index, 1);
        Languages.unshift(pinnedLangData[0]);
      }
    }
    this.languagesSubject.next({ playbookLanguageData: Languages, pinnedPlaybookLanguage: this.pinnedPlaybookLanguage });
    this.close();
  }
  checkLength(index) {
    if (this.pinnedPlaybookLanguage !== this.playbookLanguages[index].id) {
      this.playbookLanguages[index].isSelected = !this.playbookLanguages[index].isSelected;
    }
    this.checkSelectedLanguages(true);
  }
  checkSelectedLanguages(showMessage) {
    let noIsSelected = 0;
    this.playbookLanguages.map(playbookLanguage => {
      if (playbookLanguage.isSelected) {
        noIsSelected++;
      }
    });
    if (noIsSelected > 5 || noIsSelected < 2) {
      this.isAllowed = false;
      if (showMessage) {
        this.messageservice.showWarningMessage('You can only select between 2 to 5 languages.');
      }
    } else {
      this.isAllowed = true;
    }
  }
  onItemDrop(e: CdkDragDrop<any[]>) {
    moveItemInArray(this.playbookLanguages, e.previousIndex, e.currentIndex);
  }
  pinLangauge(languageId: number) {
    if (!this.pinnedPlaybookLanguage) {
      this.pinnedPlaybookLanguage = languageId;
    } else {
      this.pinnedPlaybookLanguage = null;
    }
  }
  resetSelection() {
    const constLang = cloneDeep(this.constPlaybookLanguages);
    this.close();
    constLang.forEach((eachConstPlaybookLanguage) => {
      eachConstPlaybookLanguage.isSelected = true;
    });
    this.languagesSubject.next({ playbookLanguageData: constLang, pinnedPlaybookLanguage: null });
  }
}
